<kui-modal
    #modal
    [title]="'Custom CSS'"
    [actions]="modalActions"
    (onClose)="closeModal()"
>
    <div class="p-4">
        <div class="pb-4">
            Add inline CSS overrides below. A maximum of 4096 characters are allowed. 
        </div>
        <textarea class='w-100 font-monospace' maxlength="4096" style='height: 380px; white-space: nowrap;  overflow: auto' [(ngModel)]="css"></textarea>

        <div class="pt-3 text-danger" *ngIf='errorMessage'>
            {{ errorMessage}}
        </div>
    </div>
</kui-modal>